import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Reloads the occupants list when a payroll update operation is successfully
 * executed, to reflect the changes.
 *
 * The update returns nothing, so the cache only gets the edited occupant merged
 * in, which leaves what the backend works out from the new assignments (like
 * which payrolls are relevant, once a payroll gained entries since it was read)
 * stale. Creations already reload the list on their own, so only updates are
 * reloaded on
 */
export const reloadOnPayrollsUpdate = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    collection.plugins.editingPlugin.feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.filter(({ data: { response } }) => response.updates.length > 0),
        rxjs.map(() =>
          collection.plugins.currentListPlugin.feature.actions.load
            .from('(effect) reload on payrolls update')
            .create(),
        ),
      ),
)
